module.exports = __webpack_public_path__ + "images/emoji/helicopter.3ad5052a1b6d34f32894.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/helicopter.png
// module id = zl5a
// module chunks = 14